import { createRoute, redirect } from "@tanstack/react-router";

import validation from "core/validation";

import { root } from "routes";
import Layout from "theme/ui/Layout";

import { query } from "areas/unlock/data";
import Unlock from "areas/unlock/pages/Unlock";
import Gift from "areas/unlock/pages/Gift";
import Redeem from "areas/unlock/pages/Redeem";


const _root = createRoute({
	getParentRoute: () => root,
	id: "unlock-layout",
	component: () => <Layout.Dark />
});

const index = createRoute({
	getParentRoute: () => _root,
	path: "unlock",
	beforeLoad: validation.redirect.unauthenticated,
	loader: async ({ context, location }) => {
		const { queryClient, profile } = context;
		const ssk = location.search.sub_sk;
		const cid = location.search.sub_cid;

		await queryClient.ensureQueryData(query.get(profile.id, ssk, cid));
	},
	component: () => <Unlock />
});

const gift = createRoute({
	getParentRoute: () => _root,
	path: "gift",
	beforeLoad: (params) => {
		validation.redirect.unauthenticated(params);
		const gid = sessionStorage.getItem("gift-id");
		if (gid) {
			sessionStorage.removeItem("gift-id");
			if (!params.location.search.sub_gid) return redirect({ to: "/gift", search: { sub_gid: Number(gid) } });
		}
	},
	loader: async ({ context, location }) => {
		const { queryClient, profile } = context;
		const cid = location.search.sub_cid;
		const gid = location.search.sub_gid;

		await queryClient.ensureQueryData(query.buyInfo(profile.id, cid, gid));
	},
	onLeave: () => sessionStorage.getItem("gift-id") && sessionStorage.removeItem("gift-id"),
	component: () => <Gift />
});

const redeem = createRoute({
	getParentRoute: () => _root,
	path: "redeem",
	component: () => <Redeem />,
	loader: async ({ context, location }) => {
		const { queryClient, device } = context;
		const sgk = location.search.sub_gk;

		await queryClient.ensureQueryData(query.giftInfo(sgk, device));
	},
	staticData: {
		footer: "redeem"
	}
});

const unlock = _root.addChildren([index, gift, redeem]);

export default unlock;